import { createTheme } from '@mui/material';

let theme = createTheme({
	components: {
		MuiSnackbar: {
			styleOverrides: {
				root: {
					width: '1200px',
				},
			},
		},

		MuiButton: {
			variants: [
				{
					props: { variant: 'contrast' },
					style: {
						color: '#000',
						borderColor: '#000',
						':hover': {
							backgroundColor: 'rgba(87, 141, 64, 0.9)',
						},
					},
				},
			],
		},
	},
	typography: {
		fontFamily: ['Poppins', 'Lato', 'Lucida Grande', 'Tahoma', 'Sans-Serif'].join(','),

		h4: {
			fontWeight: 400,
			color: '#0E3E45',
		},
		h5: {
			fontWeight: 400,
			color: '#0E3E45',
		},
		// Non standard headings - to be brought in line for the design system
		'dashboard-card-heading': {
			fontSize: 24,
			fontWeight: 400,
			lineHeight: '32px',
			color: '#F15B22',
		},
	},
	palette: {
		primary: {
			light: '#00b4cc',
			main: '#007E8F',
			dark: '#015864',
		},
		secondary: {
			light: '#FA875B',
			main: '#F15B22',
			dark: '#CA4F1E',
		},
		navigationButtonColor: {
			main: '#FFF',
		},
		regNumberColor: {
			main: 'rgb(241, 91, 34)',
		},
		annualMileageFont: {
			main: '#015864',
		},

		contrastThreshold: 3,
		tonalOffset: 0.2,
		background: {
			default: '#F2FBFC',
		},

		footer: {
			light: '#0e3e45',
			main: '#0e3e45',
			dark: '#0e3e45',
		},
		icon: {
			main: '#007E8F',
		},
	},
});

theme = createTheme(theme, {
	components: {
		MuiTypography: {
			defaultProps: {
				variantMapping: {
					'dashboard-card-heading': 'h2',
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					borderRadius: 0,
					'&.policy-list-item:hover': {
						backgroundColor: 'rgba(0, 126, 143, 0.12) !important',
					},
				},
			},
		},
		MuiAppBar: {
			styleOverrides: {
				root: {
					backgroundColor: theme.palette.primary.light,
					'.MuiButtonBase-root:hover': {
						backgroundColor: 'rgba(0, 126, 143, 0.5)',
					},
				},
			},
		},
		MuiFormLabel: {
			styleOverrides: {
				root: {
					color: theme.palette.common.black,
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					borderColor: theme.palette.common.black,
				},
				notchedOutline: {
					borderColor: theme.palette.common.black,
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: ({ ownerState }: { ownerState: { color: string; variant?: string } }) => ({
					...(ownerState.variant !== 'text' && {
						...(ownerState.color === 'secondary' && {
							borderColor: theme.palette.common.black,
							':hover': {
								backgroundColor: 'rgba(250, 135, 91, 0.9)',
							},
						}),
						...(ownerState.color === 'primary' && {
							borderColor: theme.palette.common.black,
							':hover': {
								backgroundColor: 'rgba(0, 180, 204, 0.9)',
							},
						}),
					}),
				}),
			},
			variants: [
				{
					props: { variant: 'link' },
					style: {
						...theme.typography.body1,
						color: theme.palette.primary.main,
						textDecoration: 'underline',
						padding: 0,
						background: 'transparent',
						'&:hover': {
							color: theme.palette.primary.light,
							background: 'transparent',
							textDecoration: 'underline',
						},
						'&:visited': {
							background: 'transparent',
							color: theme.palette.primary.main,
							'&:hover': {
								color: theme.palette.primary.light,
							},
						},
					},
				},
			],
		},
		MuiToggleButton: {
			styleOverrides: {
				root: {
					color: theme.palette.common.black,
					borderColor: theme.palette.common.black,
					'&.Mui-selected': {
						backgroundColor: theme.palette.primary.main,
						color: theme.palette.common.white,
						'&:hover': {
							backgroundColor: theme.palette.primary.main,
						},
					},
				},
			},
		},
		MuiCssBaseline: {
			styleOverrides: `
        body, html, #root {
          height: 100%;
        }
        html {
          overflow-y: scroll;
        }
        /* ===== Scrollbar CSS ===== */
        /* Firefox */
        * {
          scrollbar-width: thin;
          scrollbar-color: ${theme.palette.grey[500]} ${theme.palette.background.default};
        }

        /* Chrome, Edge, and Safari */
        *::-webkit-scrollbar {
          width: 12px;
        }

        *::-webkit-scrollbar-track {
          background: ${theme.palette.background.default};
        }

        *::-webkit-scrollbar-thumb {
          background-color: ${theme.palette.grey[500]};
          border-radius: 10px;
          border: 3px solid ${theme.palette.background.default};
        }`,
		},
		MuiCalendarPicker: {
			styleOverrides: {
				root: {
					maxWidth: '-webkit-fill-available',
				},
			},
		},
		MuiBox: {
			styleOverrides: {
				root: {
					'&.policy-status-field': {
						float: 'right',
						backgroundColor: 'rgba(0, 126, 143, 0.12)',
					},
				},
			},
		},
		MuiAvatar: {
			styleOverrides: {
				root: {
					backgroundColor: theme.palette.primary.main + ' !important',
					color: theme.palette.common.white,
				},
			},
		},
	},
});

const themeExport = theme;
export default themeExport;
